// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Svg from "../../primitives/Svg.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as Icon from "../images-and-icons/Icon.res.js";
import * as React from "react";
import * as Button from "../actions/Button.res.js";
import * as Offset from "../layout-and-structure/Offset.res.js";
import * as Spaces from "../theme/Spaces.res.js";
import * as Auth__Jwt from "../../bundles/Auth/Auth__Jwt.res.js";
import * as ReactAria from "react-aria";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as ReactDomElement from "../../primitives/ReactDomElement.res.js";
import * as Stylex from "@stylexjs/stylex";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as UseResizeObserver from "react-aria/private/utils/useResizeObserver";
let context = React.createContext(false);
let make = context.Provider;
let Provider = {
  make: make
};
let CompactContext = {
  context: context,
  Provider: Provider
};
function backgroundColor(variation) {
  if (variation === "important") {
    return "#FFFBEB";
  } else if (variation === "neutral") {
    return "#F3F3F7";
  } else if (variation === "warning") {
    return "#FFF5ED";
  } else if (variation === "danger") {
    return "#FDF2F7";
  } else if (variation === "success") {
    return "#EBFEF3";
  } else {
    return "#F2F6FC";
  }
}
function textColor(variation) {
  if (variation === "important") {
    return "#7A360D";
  } else if (variation === "neutral") {
    return "#25243A";
  } else if (variation === "warning") {
    return "#7C2112";
  } else if (variation === "danger") {
    return "#821938";
  } else if (variation === "success") {
    return "#00653E";
  } else {
    return "#354473";
  }
}
function iconColor(variation) {
  if (variation === "important") {
    return "#F9A307";
  } else if (variation === "neutral") {
    return "#25243A";
  } else if (variation === "warning") {
    return "#EA3F0C";
  } else if (variation === "danger") {
    return "#D92964";
  } else if (variation === "success") {
    return "#009F5D";
  } else {
    return "#4F70C1";
  }
}
let styles = {
  root: {
    "borderRadius-kaIpWk": "borderRadius-x12oqio5",
    "outline-kI3sdo": "outline-xwar4du",
    "display-k1xSpc": "display-x78zum5",
    "gap-kOIVth": "gap-x167g77z",
    "minHeight-kAzted": "minHeight-x1lh6h5t",
    "padding-kmVPX3": "padding-xc7ga6q",
    "position-kVAEAm": "position-x1n2onr6",
    $$css: "wino-gc:src/resources/feedback-indicators/NextBanner.res.js:81"
  },
  grow: {
    "width-kzqmXN": "width-xeq5yr9",
    $$css: "wino-gc:src/resources/feedback-indicators/NextBanner.res.js:90"
  },
  compact: {
    "gap-kOIVth": "gap-x1jnr06f",
    "paddingBlock-k8WAf4": "paddingBlock-xj8oexa",
    "paddingInline-kg3NbH": "paddingInline-xdqyycr",
    $$css: "wino-gc:src/resources/feedback-indicators/NextBanner.res.js:93"
  },
  content: {
    "alignSelf-kSGwAc": "alignSelf-xamitd3",
    "display-k1xSpc": "display-x78zum5",
    "flexDirection-kXwgrk": "flexDirection-xdt5ytf",
    "gap-kOIVth": "gap-x17d4w8g",
    $$css: "wino-gc:src/resources/feedback-indicators/NextBanner.res.js:98"
  },
  contentTitle: {
    "font-kVVagm": "font-x36xucc",
    $$css: "wino-gc:src/resources/feedback-indicators/NextBanner.res.js:104"
  },
  contentTitleCompact: {
    "font-kVVagm": "font-x1tf9s6z",
    $$css: "wino-gc:src/resources/feedback-indicators/NextBanner.res.js:107"
  },
  contentTextCompact: {
    "font-kVVagm": "font-x1dfh7bg",
    $$css: "wino-gc:src/resources/feedback-indicators/NextBanner.res.js:110"
  },
  contentTextMoreButtonCompact: {
    "font-kVVagm": "font-x10l0f84",
    $$css: "wino-gc:src/resources/feedback-indicators/NextBanner.res.js:113"
  },
  contentText: {
    "font-kVVagm": "font-xyeg6z0",
    "lineHeight-kLWn49": "lineHeight-xd4r4e8",
    "WebkitBoxOrient-kgKLqz": "WebkitBoxOrient-x1ua5tub",
    "marginTop-keoZOQ": "marginTop-x1y332i5",
    "overflow-kVQacm": "overflow-xb3r6kr",
    "position-kVAEAm": "position-x1n2onr6",
    $$css: "wino-gc:src/resources/feedback-indicators/NextBanner.res.js:116"
  },
  contentTextMoreButton: {
    "font-kVVagm": "font-x364216",
    "fontWeight-k63SB2": "fontWeight-x117nqv4",
    "lineHeight-kLWn49": "lineHeight-xd4r4e8",
    "cursor-kkrTdU": "cursor-x1ypdohk",
    "overflow-kVQacm": "overflow-xb3r6kr",
    "paddingInlineStart-kZCmMZ": "paddingInlineStart-xytt9sc",
    "position-kVAEAm": "position-x10l6tqk",
    "right-kCIrl2": "right-x3m8u43",
    ":hover_textDecorationLine-kdSwXR": "textDecorationLine-x1sur9pj",
    $$css: "wino-gc:src/resources/feedback-indicators/NextBanner.res.js:124"
  },
  Text_root: {
    "font-kVVagm": "font-xyeg6z0",
    "lineHeight-kLWn49": "lineHeight-xd4r4e8",
    "whiteSpace-khDVqt": "whiteSpace-x1fj9vlw",
    $$css: "wino-gc:src/resources/feedback-indicators/NextBanner.res.js:137"
  },
  Text_compact: {
    "font-kVVagm": "font-x1dfh7bg",
    $$css: "wino-gc:src/resources/feedback-indicators/NextBanner.res.js:142"
  },
  Text_bold: {
    "fontWeight-k63SB2": "fontWeight-x1s688f",
    $$css: "wino-gc:src/resources/feedback-indicators/NextBanner.res.js:145"
  },
  Text_italic: {
    "fontStyle-kKX8nH": "fontStyle-x1k4tb9n",
    $$css: "wino-gc:src/resources/feedback-indicators/NextBanner.res.js:148"
  },
  Text_link: {
    "color-kMwMTN": "color-x1heor9g",
    "fontWeight-k63SB2": "fontWeight-xk50ysn",
    "cursor-kkrTdU": "cursor-x1ypdohk",
    "filter-ku685b": "filter-xwq5l4r",
    ":hover_textDecorationLine-kdSwXR": "textDecorationLine-x1sur9pj",
    $$css: "wino-gc:src/resources/feedback-indicators/NextBanner.res.js:151"
  },
  Text_linkCompact: {
    "fontSize-kGuDYH": "fontSize-x1j6dyjg",
    $$css: "wino-gc:src/resources/feedback-indicators/NextBanner.res.js:160"
  },
  Gap_root: {
    "borderStyle-ksu8eU": "borderStyle-xng3xce",
    "borderWidth-kMzoRj": "borderWidth-xc342km",
    "visibility-k33iCy": "visibility-xlshs6z",
    "margin-kogj98": "margin-x1ghz6dp",
    $$css: "wino-gc:src/resources/feedback-indicators/NextBanner.res.js:163"
  }
};
function effectiveTarget(href, target) {
  if (href !== undefined && target !== undefined && target === "_blank" && href.startsWith("/") && !href.startsWith("//") && Stdlib_Option.mapOr(Auth__Jwt.get(), false, Auth__Jwt.isImpersonated)) {
    return "_self";
  } else {
    return target;
  }
}
function styleProps(italic, bold, link, compact) {
  return Stylex.props(styles.Text_root, compact ? styles.Text_compact : {}, bold ? styles.Text_bold : {}, italic ? styles.Text_italic : {}, link ? styles.Text_link : {}, link && compact ? styles.Text_linkCompact : {});
}
let make$1 = React.memo(props => {
  let onPress = props.onPress;
  let href = props.href;
  let __bold = props.bold;
  let __italic = props.italic;
  let text = props.text;
  let italic = __italic !== undefined ? __italic : false;
  let bold = __bold !== undefined ? __bold : false;
  let compact = React.useContext(context);
  let link = Stdlib_Option.isSome(href) || Stdlib_Option.isSome(onPress);
  let match = styleProps(italic, bold, link, compact);
  let className = match.className;
  let match$1 = ReactAria.useLink({
    elementType: Stdlib_Option.isSome(href) ? "a" : "span",
    href: href,
    target: effectiveTarget(href, props.target),
    onPress: Stdlib_Option.map(onPress, onPress => param => onPress())
  }, undefined);
  let linkProps = match$1.linkProps;
  if (href !== undefined) {
    let newrecord = {
      ...linkProps
    };
    return JsxRuntime.jsx("a", (newrecord.className = className, newrecord.children = text, newrecord));
  }
  if (!link) {
    return JsxRuntime.jsx("span", {
      children: text,
      className: className
    });
  }
  let newrecord$1 = {
    ...linkProps
  };
  return JsxRuntime.jsx("span", (newrecord$1.className = className, newrecord$1.children = text, newrecord$1));
});
let Text = {
  effectiveTarget: effectiveTarget,
  styleProps: styleProps,
  make: make$1
};
function styleProps$1(space) {
  return Stylex.props(styles.Gap_root, {
    paddingBottom: String(Spaces.toFloat(space)) + "px"
  });
}
function NextBanner$Gap(props) {
  let __space = props.space;
  let space = __space !== undefined ? __space : "none";
  let match = styleProps$1(space);
  return JsxRuntime.jsx("hr", {
    className: match.className,
    style: match.style
  });
}
let Gap = {
  styleProps: styleProps$1,
  make: NextBanner$Gap
};
function buttonTone(variation) {
  if (variation === "important") {
    return {
      NAME: "neutral",
      VAL: {
        accent: true
      }
    };
  } else if (variation === "neutral") {
    return {
      NAME: "neutral",
      VAL: {
        accent: false
      }
    };
  } else if (variation === "danger" || variation === "warning") {
    return "danger";
  } else if (variation === "success") {
    return "success";
  } else {
    return "information";
  }
}
function styleProps$2(variation, compact, grow) {
  return Stylex.props(styles.root, grow ? styles.grow : {}, compact ? styles.compact : {}, {
    backgroundColor: backgroundColor(variation)
  });
}
function contentStyleProps() {
  return {
    className: "alignSelf-xamitd3 display-x78zum5 flexDirection-xdt5ytf gap-x17d4w8g",
    "data-style-src": "wino-gc:src/resources/feedback-indicators/NextBanner.res.js:98"
  };
}
function contentTitleStyleProps(variation, compact) {
  return Stylex.props(styles.contentTitle, compact ? styles.contentTitleCompact : {}, {
    color: textColor(variation)
  });
}
function contentTextStyleProps(variation, maxLines, clamped, expanded, compact) {
  return Stylex.props(styles.contentText, compact ? styles.contentTextCompact : {}, {
    color: textColor(variation),
    WebkitLineClamp: String(maxLines),
    display: expanded ? "inline" : "-webkit-box",
    paddingRight: !expanded && clamped ? "23px" : "0px"
  });
}
function contentTextMoreButtonStyleProps(variation, maxLines, emphasis, compact) {
  return Stylex.props(styles.contentTextMoreButton, compact ? styles.contentTextMoreButtonCompact : {}, {
    fontWeight: emphasis ? "bold" : "normal",
    backgroundColor: backgroundColor(variation),
    boxShadow: backgroundColor(variation) + " -5px 0 4px 0",
    top: String((maxLines - 1 | 0) * 18 | 0) + "px"
  });
}
function iconElement(variation, compact) {
  let fill = iconColor(variation);
  let match = compact ? [14, 15] : [20, 17];
  let height = match[1];
  let width = match[0];
  if (variation === "warning" || variation === "important") {
    return JsxRuntime.jsx(Icon.make, {
      name: "status_warning",
      fill: fill,
      width: width,
      height: height,
      bold: true
    });
  } else if (variation === "danger") {
    return JsxRuntime.jsx(Icon.make, {
      name: "status_nok",
      fill: fill,
      width: width,
      height: height,
      bold: true
    });
  } else if (variation === "success") {
    return JsxRuntime.jsx(Icon.make, {
      name: "status_ok",
      fill: fill,
      width: width,
      height: height,
      bold: true
    });
  } else {
    return JsxRuntime.jsx("div", {
      children: JsxRuntime.jsxs(Svg.make, {
        children: [JsxRuntime.jsx(Svg.Path.make, {
          d: "M7.19314 5.5998C7.19314 5.15798 7.55131 4.7998 7.99314 4.7998H8.00647C8.4483 4.7998 8.80647 5.15798 8.80647 5.5998C8.80647 6.04163 8.4483 6.3998 8.00647 6.3998H7.99314C7.55131 6.3998 7.19314 6.04163 7.19314 5.5998Z",
          fill: fill
        }), JsxRuntime.jsx(Svg.Path.make, {
          d: "M7.9998 7.1998C8.44163 7.1998 8.7998 7.55798 8.7998 7.9998V9.5998C9.24163 9.5998 9.5998 9.95798 9.5998 10.3998C9.5998 10.8416 9.24163 11.1998 8.7998 11.1998H7.1998C6.75798 11.1998 6.3998 10.8416 6.3998 10.3998C6.3998 9.95798 6.75798 9.5998 7.1998 9.5998V8.7998C6.75798 8.7998 6.3998 8.44163 6.3998 7.9998C6.3998 7.55798 6.75798 7.1998 7.1998 7.1998H7.9998Z",
          fill: fill
        }), JsxRuntime.jsx(Svg.Path.make, {
          d: "M0.799805 7.9998C0.799805 4.02335 4.02335 0.799805 7.9998 0.799805C11.9763 0.799805 15.1998 4.02335 15.1998 7.9998C15.1998 11.9763 11.9763 15.1998 7.9998 15.1998C4.02335 15.1998 0.799805 11.9763 0.799805 7.9998ZM7.9998 2.3998C4.90701 2.3998 2.3998 4.90701 2.3998 7.9998C2.3998 11.0926 4.90701 13.5998 7.9998 13.5998C11.0926 13.5998 13.5998 11.0926 13.5998 7.9998C13.5998 4.90701 11.0926 2.3998 7.9998 2.3998Z",
          fill: fill
        })],
        width: String(width),
        height: String(height),
        viewBox: "0 0 16 16"
      }),
      style: {
        display: "flex"
      }
    });
  }
}
function copyButtonElement(variation, copied, onPressCopy, onCopied) {
  if (onPressCopy !== undefined) {
    return JsxRuntime.jsx(Offset.make, {
      children: JsxRuntime.jsx(Button.make, {
        ariaLabel: "copy",
        variant: {
          NAME: "ghost",
          VAL: {}
        },
        tone: buttonTone(variation),
        size: "small",
        bold: copied,
        active: copied,
        inert: copied,
        icon: copied ? "tick" : "duplicate_v1",
        tooltipText: copied ? I18n.t("Copied to clipboard!") : I18n.t("Copy"),
        onPress: () => {
          onPressCopy();
          onCopied();
        }
      }),
      top: -6,
      right: -6,
      width: 32,
      height: 32
    });
  } else {
    return null;
  }
}
function closeButtonElement(variation, onRequestClose) {
  if (onRequestClose !== undefined) {
    return JsxRuntime.jsx(Offset.make, {
      children: JsxRuntime.jsx(Button.make, {
        ariaLabel: I18n.t("Close"),
        variant: {
          NAME: "ghost",
          VAL: {
            bordered: false
          }
        },
        tone: buttonTone(variation),
        size: "small",
        icon: "cross",
        onPress: () => onRequestClose()
      }),
      top: -6,
      right: -6,
      width: 32,
      height: 32
    });
  } else {
    return null;
  }
}
function NextBanner(props) {
  let __grow = props.grow;
  let __compact = props.compact;
  let __expandLabelEmphasis = props.expandLabelEmphasis;
  let __expandLabel = props.expandLabel;
  let __maxLines = props.maxLines;
  let title = props.title;
  let variation = props.variation;
  let maxLines = __maxLines !== undefined ? __maxLines : 0;
  let expandLabel = __expandLabel !== undefined ? __expandLabel : I18n.t("More");
  let expandLabelEmphasis = __expandLabelEmphasis !== undefined ? __expandLabelEmphasis : false;
  let compact = __compact !== undefined ? __compact : false;
  let grow = __grow !== undefined ? __grow : false;
  let textContentRef = React.useRef(null);
  let match = React.useState(() => false);
  let setTextClamped = match[1];
  let textClamped = match[0];
  let match$1 = React.useState(() => false);
  let setExpanded = match$1[1];
  let expanded = match$1[0];
  let match$2 = React.useState(() => false);
  let setCopied = match$2[1];
  let copied = match$2[0];
  let textClampingHandler = React.useCallback(() => {
    let domElement = ReactDomElement.fromRef(textContentRef);
    if (domElement === undefined) {
      return;
    }
    let domElement$1 = Primitive_option.valFromOption(domElement);
    setTextClamped(param => domElement$1.scrollHeight > domElement$1.clientHeight);
  }, [textContentRef]);
  React.useLayoutEffect(() => {
    textClampingHandler();
  }, []);
  React.useEffect(() => {
    if (!copied) {
      return;
    }
    let timer = setTimeout(() => setCopied(param => false), 1500);
    return () => {
      clearTimeout(timer);
    };
  }, [copied]);
  UseResizeObserver.useResizeObserver({
    ref: textContentRef,
    onResize: textClampingHandler
  });
  let match$3 = {
    className: "alignSelf-xamitd3 display-x78zum5 flexDirection-xdt5ytf gap-x17d4w8g",
    "data-style-src": "wino-gc:src/resources/feedback-indicators/NextBanner.res.js:98"
  };
  let match$4 = contentTitleStyleProps(variation, compact);
  let match$5 = contentTextStyleProps(variation, maxLines, textClamped, expanded, compact);
  let match$6 = contentTextMoreButtonStyleProps(variation, maxLines, expandLabelEmphasis, compact);
  let match$7 = styleProps$2(variation, compact, grow);
  return JsxRuntime.jsx(make, {
    value: compact,
    children: JsxRuntime.jsxs("div", {
      children: [iconElement(variation, compact), JsxRuntime.jsxs("div", {
        children: [title !== undefined ? JsxRuntime.jsx("span", {
          children: title,
          className: match$4.className,
          style: match$4.style
        }) : null, JsxRuntime.jsxs("span", {
          children: [props.children, textClamped && !expanded ? JsxRuntime.jsx("span", {
            children: expandLabel,
            className: match$6.className,
            style: match$6.style,
            onClick: param => setExpanded(param => true)
          }) : null],
          ref: Primitive_option.some(textContentRef),
          className: match$5.className,
          style: match$5.style
        })],
        className: match$3.className,
        style: match$3.style
      }), copyButtonElement(variation, copied, props.onPressCopy, () => setCopied(param => true)), closeButtonElement(variation, props.onRequestClose)],
      className: match$7.className,
      style: match$7.style
    })
  });
}
let make$2 = NextBanner;
export { CompactContext, backgroundColor, textColor, iconColor, styles, Text, Gap, buttonTone, styleProps$2 as styleProps, contentStyleProps, contentTitleStyleProps, contentTextStyleProps, contentTextMoreButtonStyleProps, iconElement, copyButtonElement, closeButtonElement, make$2 as make };
/* context Not a pure module */